
import React from 'react';
import { connect } from 'react-redux';
import GradientCards from '../../../../../_components/common/GradientCards'

import Navbar from '../../../../../_components/common/Navbar';
import SideNavBar from '../../../../../_components/common/SideNavBar'
import { orgAdminAreaData, AnalyzeData } from '../../../OrgAdminArea/SidebarData'
import AnalysisNavBar from '../../../../../_components/common/AnalysisNavBar'
import FocusAreaParameters from './FocusAreaParameters'
import CircularButtonGroup from '../../../../../_components/common/CircularButtonGroup'
import { buttonGroupData, buttonGroupData_all } from './FocusAreaButtonGroupData'
import DynamicGradientTables from '../../../../../_components/common/DynamicGradientTables'
import './index.css'
import { saveModulePermissionsAction, orgAdminAction, saveTeamDetailsAction, analyseActions } from '../../../../../_actions';
import { AnalyzeAction } from '../../../../../_actions/Analyze/analyze.action'
import dataFormater, {focus_area_all_linearBackgroundChange} from '../../dataFormater'
import buttonDataFormater from '../../buttonDataFormater'

import RoutableSelects from '../../../../../_components/common/RoutableSelects'
import { ori_bas_attr_fil } from '../../orientation_based_attribute_filter'
import {global_data} from '../../globalData'

import FocusAreaIcon from '../../../../../images/focusAreasIcon.png';

import lifeDetail from '../../../../../images/lifeDetailTitle.png';
import involvementDetail from '../../../../../images/involvementDetailTitle.png';
import disciplineDetail from '../../../../../images/disciplineDetailTitle.png';


class FocusArea extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            teamName: '',
            teamId: '',
            getPaUserPermissionListResponse: '',
            navData: [],
            data: [],
            data_each_orientation: [],
            buttonDataFormater_each_orientation: [{
                img: FocusAreaIcon,
                link: `/organisation/${props.match.params.id}/user/focus-area`,
                name: "All",
                tooltip_id: 0,
                id: 0,
            }],
            buttonDataFormater_for_all: [{
                img: FocusAreaIcon,
                link: `/organisation/${props.match.params.id}/user/focus-area`,
                name: "All",
                tooltip_id: 0,
                id: 0,
            }],
            class_name: {
                main_container: 'd-flex flex-row flex-wrap align-items-start col-12',
                container: {
                    container: "d-flex flex-column col-sm-4 col-md-4 col-lg-4 w-100 p-1",
                    style: {
                        margin: 1,
                    }
                },
                header_container: {
                    header_container: 'w-100 py-3 my-1',
                    style: {
                        paddingLeft: 0,
                        margin: 1
                    }
                },
                header_container_non_routable: {
                    header_container_non_routable: 'd-flex flex-column align-items-center justify-content-center text-white ml-4 ',
                    header_container_non_routable_title: 'font-class-compatibility-title font-weight-bold py-1',
                    header_container_non_routable_optional: 'font-class-compatibility-optional',
                },
                child_container: {
                    child_container: "d-flex flex-column col-12 flex-wrap w-100 px-0",
                    style: {
                        margin: 1
                    }
                },
                child_content_container: {
                    child_content_container: 'd-flex col-sm-12 col-md-12 col-lg-12 py-2 px-4 my-1 text-dark text-center',
                    child_content_container_header: 'font-weight-bold py-1 font-class-compatibility-title',
                    child_content_container_desc: 'font-weight-bold font-italic',
                    child_content_container_footer: '',
                },
                focusAreaLoader: false
            },
        }
    }

    componentDidUpdate(prevProp) {
        if(prevProp.saveAssesorGroupListResponse !== this.props.saveAssesorGroupListResponse) {
            if(this.props.saveAssesorGroupListResponse !== '') {
                this.setState({filterData: this.props.saveAssesorGroupListResponse})
            }
        }
        if(prevProp.AnalyzeDataResonse != this.props.AnalyzeDataResonse) {
            if(this.props.AnalyzeDataResonse !== '') {
                this.setState({
                    buttonDataFormater_each_orientation: [{
                        img: FocusAreaIcon,
                        link: `/organisation/${this.props.match.params.id}/user/focus-area`,
                        name: "All",
                        tooltip_id: 0,
                        id: 0,
                    }],
                    buttonDataFormater_for_all: [{
                        img: FocusAreaIcon,
                        link: `/organisation/${this.props.match.params.id}/user/focus-area`,
                        name: "All",
                        tooltip_id: 0,
                        id: 0,
                    }],
                    data:[],
                    data_each_orientation:[],
                },() => {
                    this.setState({
                        data: dataFormater(this.props,this.props.AnalyzeDataResonse.data,"focus_area_all",{child_content: true}),
                        data_each_orientation: dataFormater(this.props,this.props.AnalyzeDataResonse.data,"focus_area_of_each_orientation",{child_content: false}),
                        buttonDataFormater_each_orientation: this.state.buttonDataFormater_each_orientation.concat(buttonDataFormater(this.props,dataFormater(this.props,this.props.AnalyzeDataResonse.data,"focus_area_of_each_orientation",{child_content: false}),"focus_area_orientation")),
                        buttonDataFormater_for_all: this.state.buttonDataFormater_for_all.concat(buttonDataFormater(this.props,dataFormater(this.props,this.props.AnalyzeDataResonse.data,"focus_area_all",{child_content: false}),"focus_area_all")),
                        focusAreaLoader: true
                    }, () => {
                        this.setState({
                            focusAreaLoader: false
                        })
                    })
                })
            }
        }
        if(prevProp.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }
    }

    componentDidMount() {

        this.props.dispatch(saveModulePermissionsAction.requestModulePermissionsHandler())
        if (this.props.saveModulePermissionsResponse !== '') {
            this.props.saveModulePermissionsResponse.filter(
                (data, i) => {
                    if (data.module_list__module_name === 'Focus Areas') {
                        return data
                    }
                }
            ).length === 0 &&
                this.props.history.push(`/organisation/${this.props.match.params.id}/user/dashboard`)
        }
         //filter data
         if(this.props.saveAssesorGroupListResponse !== '') {
            this.setState({filterData: this.props.saveAssesorGroupListResponse})
        }

        //Analyze Data
        if(this.props.AnalyzeDataResonse !== '') {
            this.setState({
                focusAreaLoader: true,
                data: dataFormater(this.props,this.props.AnalyzeDataResonse.data,"focus_area_all",{child_content: true}),
                data_each_orientation: dataFormater(this.props,this.props.AnalyzeDataResonse.data,"focus_area_of_each_orientation",{child_content: false}),
                buttonDataFormater_each_orientation: this.state.buttonDataFormater_each_orientation.concat(buttonDataFormater(this.props,dataFormater(this.props,this.props.AnalyzeDataResonse.data,"focus_area_of_each_orientation",{child_content: false}),"focus_area_orientation")),
                buttonDataFormater_for_all: this.state.buttonDataFormater_for_all.concat(buttonDataFormater(this.props,dataFormater(this.props,this.props.AnalyzeDataResonse.data,"focus_area_all",{child_content: false}),"focus_area_all")),
            },() => {
                this.setState({
                    focusAreaLoader: false
                })
            })
        }

        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})
    }

    // onChangeTeam = (teamDetails) => {
    //     const team = {
    //         "team_id": teamDetails.analytics_team_id
    //     }
    //     this.props.dispatch(analyseActions.getAssessorGroupsHandler(team, () => {
    //         this.props.dispatch(analyseActions.saveAssessorGroups(this.props.assessorGroupsResponse))
    //     }))
    // }

    doSomthing = (data) => {
        this.setState({filterData : data}, () => {
            this.props.dispatch(analyseActions.saveAssessorGroups(this.state.filterData))            
        })
    }

    renderFocusAreaBasedOnEachOrientation() {
        var result = this.state.data_each_orientation.map((obj,key) => {
            if(this.props.match.params.orientcategory == obj.orientation_name.toLowerCase()) {
                const newArr = obj.data;
                return (
                    <div className="d-flex flex-wrap align-items-center col-12 gradient-flex mt-5" style={{ paddingLeft: 20, paddingRight: 20 }}>
                        <FocusAreaParameters orientationLvl={true} showAllFocusAreas={false} graphData={obj} data={newArr} orientcategory={this.props.match.params.orientcategory} buttonGroupData={this.state.buttonDataFormater_each_orientation} heading={`Top Focus Area to improve the team's ${this.props.match.params.orientcategory} Orientation`} headingProp={false} mainData={{ header: '', icon: '' }} />
                        <CircularButtonGroup className="pr-0" buttonGroupData={this.state.buttonDataFormater_each_orientation} swotCatagory={this.props.match.params.orientcategory == undefined ? 0 : this.props.match.params.orientcategory} singleButton={false} />
                    </div>
                )
            }
        })
        return result
    }

    renderFocusAreaBasedOnAll() {
        var result = this.state.data.map((obj,key) => {
            if(this.props.match.params.allcategory == obj.id ) {
                var arr = []
                obj.child_content.map((val,index) => {
                    arr.push({
                        name: `${val.child_header}`,
                        discription: val.child_content,
                        background_color: focus_area_all_linearBackgroundChange(obj.header_text),
                        footer_text: '(' + ori_bas_attr_fil(`${val.child_header}`) + ' ' + 'Orientation)',
                        // act_now: true
                    })
                })

                

                return (
                    <div className="d-flex flex-wrap align-items-center col-12 gradient-flex" style={{ paddingLeft: 20, paddingRight: 20 }}>
                        <FocusAreaParameters orientationLvl={false} showAllFocusAreas={true} graphData={obj} data={arr} orientcategory={this.props.match.params.allcategory} buttonGroupData={this.state.buttonDataFormater_for_all} heading={`Top 2 Focus Areas to improve the team's ${obj.id == 'life' ? 'Operational Capabilities' : obj.id == 'involvement' ? 'Level of Involvement' : 'sense of Structure and Timing'}`} headingProp={true} mainData={{ header: `${obj.header_text}`, icon: obj.id === 'life' ? lifeDetail : obj.id === 'involvement' ? involvementDetail : disciplineDetail }} />
                        <CircularButtonGroup className="pr-0" buttonGroupData={this.state.buttonDataFormater_for_all} swotCatagory={this.props.match.params.allcategory} singleButton={false} />
                    </div> 
                )
            }
        })
        return result
    }

    render() {
        const { data, navData, focus_category_data_0 } = this.state;
        const { saveAssesorGroupListResponse } = this.props;
        return (
            <div>
                <Navbar navItems={navData} backgroundColor="black" />
                < div className="container-post-nav">
                    <SideNavBar
                            analyzeFilterData={this.state.filterData}
                            isAnalyse = {true}
                            organisationName={localStorage.getItem('orgName')}
                            orgId={this.props.match.params.id}
                            teamId={localStorage.getItem('teamId')}
                            teamName={localStorage.getItem('teamName')}
                            callBack={(data) => this.doSomthing(data)}
                        // onChangeTeam={(data) => this.onChangeTeam(data)}
                        />
                    <div className="analyz-container">
                        <AnalysisNavBar analyticsData={this.props.saveModulePermissionsResponse} orgId={this.props.match.params.id} analyticsType={'people'} />
                        {
                             this.props.singleValidatorResponse ?
                             <p className="m-3 text-center">
                                 Team Members should be more than 2
                             </p>:
                                <React.Fragment>
                                    {
                                        this.props.AnalyzeDataResonse == '' ?
                                            !this.props.getAnalyzeError ?
                                                this.props.teamAvailabilityBoolean ?
                                                    <p className="text-center mt-4">
                                                        <i className="fas fa-spinner fa-spin " ></i>
                                                        &nbsp;loading
                                                    </p>
                                                :
                                                    <p className="text-center mt-4">
                                                        &nbsp;{this.props.teamAvailabilityText}
                                                    </p>
                                            :
                                                <p className="text-center my-5">{this.props.getAnalyzeError.message}</p>
                                        :
                                            this.state.focusAreaLoader ?
                                                <p className="text-center mt-4">
                                                    <i className="fas fa-spinner fa-spin " ></i>
                                                    &nbsp;loading
                                                </p>
                                            :
                                                <div className={'offset-xl-1 col-xl-10'}>
                                                    {
                                                        this.props.match.params.allcategory != undefined ?
                                                            <div>
                                                                <div className="d-flex justify-content-center drop-down-container my-3">
                                                                    <h6 className="d-flex justify-content-end align-items-center mb-0 px-2 ">Choose Orientation:</h6>
                                                                    <RoutableSelects swotid={this.props.match.params.allcategory} buttonGroupData={this.state.buttonDataFormater_each_orientation} {...this.props} />
                                                                </div>
                                                                {/* allcategory div */}
                                                                {
                                                                    this.renderFocusAreaBasedOnAll()
                                                                }
                                                                {/* End */}
                                                            </div> :
                                                            <div>
                                                                {/* orientcategory div  */}
                                                                {
                                                                    this.props.match.params.orientcategory == undefined ?
                                                                        <div className="d-flex heading-container" style={{ paddingLeft: 40, paddingRight: 40 }}>
                                                                            <h6 className="d-flexalign-items-center mb-0 px-2 font-weight-bold">FOCUS AREAS</h6>
                                                                            <p className="mb-0 px-1 font-weight-bold font-italic">(Team's TWO potential pitfalls and recommended preventive actions)</p>
                                                                        </div> :
                                                                        null
                                                                }
                                                                {
                                                                    this.props.match.params.orientcategory == undefined ?
                                                                        <div className="d-flex flex-wrap align-items-center col-12 gradient-flex" style={{ paddingLeft: 0, paddingRight: 0 }}>
                                                                            {
                                                                                this.state.data.length !=0 ?
                                                                                <React.Fragment>
                                                                                    <DynamicGradientTables classNameProps={this.state.class_name} data={this.state.data} />
                                                                                    <CircularButtonGroup className="pr-0" buttonGroupData={this.state.buttonDataFormater_each_orientation} swotCatagory={this.props.match.params.orientcategory == undefined ? 0 : this.props.match.params.orientcategory} singleButton={false} />
                                                                                </React.Fragment> :
                                                                                null
                                                                            }
                                                                        </div> :
                                                                        <div>
                                                                            {/* <div className="d-flex justify-content-center drop-down-container my-3">
                                                                                <h6 className="d-flex justify-content-end align-items-center mb-0 px-2 ">Choose Orientation:</h6>
                                                                                <RoutableSelects swotid={this.props.match.params.orientcategory} buttonGroupData={buttonGroupData} {...this.props} />
                                                                            </div> */}
                                                                            {
                                                                                this.renderFocusAreaBasedOnEachOrientation()                      
                                                                            }
                                                                        </div>
                                                                }
                                                            </div>
                                                    }
                                                    {/* End */}
                                                </div>
                                    }
                                </React.Fragment>
                        }                
                    </div>
                </ div>
            </div>


        );
    }
}


function mapStateToProps(state) {
    const saveModulePermissionsResponse = state.saveModulePermissionsReducer.data;

    const { getModulePermissionsLoading } = state.getModulePermissionsListReducer;
    const getModulePermissionsListError = state.getModulePermissionsListReducer.error;
    const getModulePermissionsListResponse = (!getModulePermissionsLoading && !getModulePermissionsListError) ? state.getModulePermissionsListReducer.data.data.message : '';

    const saveTeamDetailsResponse = state.saveTeamDetailsReducer.data;

    const { getPaUserPermissionListLoading } = state.getPaUserPermissionListReducer;
    const getPaUserPermissionListError = state.getPaUserPermissionListReducer.error;
    const getPaUserPermissionListResponse = (!getPaUserPermissionListLoading && !getPaUserPermissionListError) ? state.getPaUserPermissionListReducer.data.data.message : '';

    const { assessorGroupsLoading } = state.assessorGroupsReducer;
    const assessorGroupsError = state.assessorGroupsReducer.error;
    const assessorGroupsResponse = (!assessorGroupsLoading && !assessorGroupsError) ? state.assessorGroupsReducer.data.data : '';

    //Analyze
    const { getAnalyzeLoading } = state.getAnalyzeData
    const getAnalyzeError = state.getAnalyzeData.error
    const AnalyzeDataResonse = (!getAnalyzeLoading && !getAnalyzeError) ?  state.getAnalyzeData.data : '';

    //Header Permission
    const { headPerLoading } = state.headerPermissionReducer
    const headPerLoadingError = state.headerPermissionReducer.error
    const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';

    const saveAssesorGroupListResponse = state.saveAssesorGroupListReducer.data;
    const saveAssesorIdsResponse = state.saveAssesorIdsReducer.data;
    const singleValidatorResponse = state.singleValidatorReducer.data;
    
    const teamAvailabilityText = state.teamAvailabilityReducer.data;
    const teamAvailabilityBoolean = state.teamAvailabilityReducer.availibility;

    return {
        saveModulePermissionsResponse,
        getModulePermissionsListResponse,
        saveTeamDetailsResponse,
        getPaUserPermissionListResponse,
        assessorGroupsResponse,
        saveAssesorGroupListResponse,
        saveAssesorIdsResponse,
        AnalyzeDataResonse,
        getAnalyzeLoading,
        getAnalyzeError,
        singleValidatorResponse,
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError,

        teamAvailabilityText,
        teamAvailabilityBoolean,
    }
}

export default connect(mapStateToProps)(FocusArea)


// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/Category/FocusArea/index.js